"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["Null"] = "null";
    CountryCode["Canada"] = "CA";
    CountryCode["Denmark"] = "DK";
    CountryCode["Finland"] = "FI";
    CountryCode["France"] = "FR";
    CountryCode["Germany"] = "DE";
    CountryCode["Ireland"] = "IE";
    CountryCode["Sweden"] = "SE";
    CountryCode["Norway"] = "NO";
    CountryCode["UnitedStates"] = "US";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
